


















import { Nota } from '@/types/_'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { permissionService } from '@/services/permission.service'

@Component
export default class ComponentSurgeryAnnotation extends Vue {
  @Prop({ required: true }) nota!: Nota

  get nomeDisplay(): string {
    return this.nota.criadaPor && this.nota.criadaPor.nome
      ? this.nota.criadaPor.nome
      : ''
  }

  get dataHoraDisplay(): string {
    return this.nota.criadaEm || ''
  }

  get detalhesDisplay(): string {
    return this.nota.anotacao || ''
  }

  get showDeleteButton(): boolean {
    if (!this.userHasWritingAnnotationPermission) {
      return false
    }

    if (this.nota.anotacaoAutomatica) {
      return false
    }

    if (this.$user.profile.sub === (this.nota.criadaPor && this.nota.criadaPor.id)) {
      return true
    }

    return false
  }

  get userHasWritingAnnotationPermission() {
    return permissionService.hasPermission('agendamento.medica.anotacoes.editar')
  }

  get anexoUrl(): string {
    return this.nota.anexos && this.nota.anexos.length > 0
      ? this.nota.anexos[0].uri
      : ''
  }

  get anexoNome(): string {
    return this.nota.anexos && this.nota.anexos.length > 0
      ? this.nota.anexos[0].nomeOriginalArquivo
      : ''
  }

  get mensagemAnexo(): string {
    return `Anexo: ${this.anexoNome}`
  }

  get dataFormatada(): string {
    return this.formatarData(this.dataHoraDisplay)
  }

  formatarData(dataStr: string): string {
    if (!dataStr) return ''
    const data = new Date(dataStr)
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(data.getTime())) return ''
    const dia = `0${data.getDate()}`.slice(-2)
    const mes = `0${data.getMonth() + 1}`.slice(-2)
    const ano = data.getFullYear()
    const horas = `0${data.getHours()}`.slice(-2)
    const minutos = `0${data.getMinutes()}`.slice(-2)
    return `${dia}/${mes}/${ano} às ${horas}h${minutos}`
  }

  onDelete() {
    this.$emit('deleteAnnotation', {
      surgerySolicitationId: this.nota.solicitacaoId,
      annotationId: this.nota.id,
    })
  }
}
